<input
  *ngIf="checkbox"
  type="checkbox"
  [id]="forId"
  [checked]="isSelected"
  [disabled]="isDisabled && !isSelected"
  (change)="selectInputOption.emit($event.target['checked'])" />
<input
  *ngIf="!checkbox"
  type="radio"
  name="radio"
  [id]="forId"
  [checked]="isSelected"
  (change)="selectInputOption.emit($event.target['checked'])" />
<label
  class="input-option"
  [for]="forId"
  [ngClass]="{ 'selected': isSelected, 'disabled': isDisabled && !isSelected, 'appear-disabled': appearDisabled }">
  <p class="input-copy">{{ answerText }}</p>
  <div class="toggle"></div>
</label>
